import React, { useEffect, useState } from 'react';
import { SVGMap } from 'react-svg-map';
import 'react-svg-map/lib/index.css';
import world from '@svg-maps/world';
import Header from '../component/Header';

const highlightedCountries = {
  GB: "#f44336",  // United Kingdom - red
  US: "#2196f3",  // United States - blue
  CA: "#4caf50",  // Canada - green
  AU: "#ff9800",  // Australia - orange
  IN: "#9c27b0",  // India - purple
  FR: "#00bcd4",  // France - cyan
  SG: "#e91e63",  // Singapore - pink
};

const countryNames = {
  GB: "United Kingdom",
  US: "United States",
  CA: "Canada",
  AU: "Australia",
  IN: "India",
  FR: "France",
  SG: "Singapore",
};

const defaultFillColor = "#00bcd4"; // You can change this to any color you want

export default function Clientele() {
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, name: "" });

  const [active, setActive] = useState('');

  const handleLocationMouseOver = (event) => {
    console.log('Location event', event?.target?.id)
    setActive(event?.target?.id)
    const name = event.target.getAttribute("name");
    const x = event.clientX;
    const y = event.clientY;
    setTooltip({ visible: true, x, y, name });
  };

  const handleLocationMouseOut = () => {
    setActive('')
    setTooltip({ visible: false, x: 0, y: 0, name: "" });
  };

  console.log('active', active)

  return (
    <>
      <Header />
      <section className='clientele-page bottom p-l-r' id={`mapIdLocation${active}`}>
        <div className='clientele-page-2'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12'>
                <div class="mental-health-content">
                  <h3 class="heading2 text_gradient">
                    Clientele
                  </h3>
                  <p>Join 10 Million People Today
                    To improve your wellbeing
                  </p>
                </div>
              </div>
              <div className=' col-xl-3 col-lg-4 order_2'>
                <div className='download-section-client'>
                  <h4>The Beyond Lifestyle Users</h4>
                  <ul>
                    {/* <li id='gb' className={active == 'gb' ? 'active' : ''} onMouseEnter={() => setActive('gb')} onMouseLeave={() => setActive('')}><span></span>UK <p>(20K)</p></li>
                    <li id='us' className={active == 'us' ? 'active' : ''} onMouseEnter={() => setActive('us')} onMouseLeave={() => setActive('')}><span></span>USA <p>(20K)</p></li>
                    <li id='ca' className={active == 'ca' ? 'active' : ''} onMouseEnter={() => setActive('ca')} onMouseLeave={() => setActive('')}><span></span>Canada <p>(20K)</p></li>
                    <li id='au' className={active == 'au' ? 'active' : ''} onMouseEnter={() => setActive('au')} onMouseLeave={() => setActive('')}><span></span>Australia <p>(20K)</p></li>
                    <li id='in' className={active == 'in' ? 'active' : ''} onMouseEnter={() => setActive('in')} onMouseLeave={() => setActive('')}><span></span>India <p>(20K)</p></li>
                    <li id='fr' className={active == 'fr' ? 'active' : ''} onMouseEnter={() => setActive('fr')} onMouseLeave={() => setActive('')}><span></span>France <p>(20K)</p></li> */}
                    <li id='MiddleEast' className={active == 'bh' || active == 'ir' || active == 'iq' || active == 'il' || active == 'jo' || active == 'kw' || active == 'lb' || active == 'om' || active == 'ps' || active == 'qa' || active == 'sa' || active == 'sy' || active == 'tr' || active == 'ae' || active == 'ye' || active == 'MiddleEast' ? 'active' : ''} onMouseEnter={() => setActive('MiddleEast')} onMouseLeave={() => setActive('')}><span></span>Middle East - <p>(350K)</p></li>
                    <li id='AsiaPacific' className={active == 'af' || active == 'au' || active == 'bd' || active == 'bt' || active == 'bn' || active == 'kh' || active == 'cn' || active == 'tl' || active == 'fj' || active == 'in' || active == 'id' || active == 'jp' || active == 'kz' || active == 'ki' || active == 'la' || active == 'my' || active == 'mv' || active == 'mn' || active == 'mm' || active == 'np' || active == 'nz' || active == 'kp' || active == 'pk' || active == 'pg' || active == 'ph' || active == 'ws' || active == 'sg' || active == 'sb' || active == 'kr' || active == 'lk' || active == 'tw' || active == 'th' || active == 'to' || active == 'tv' || active == 'vu' || active == 'vn' || active == 'AsiaPacific' ? 'active' : ''} onMouseEnter={() => setActive('AsiaPacific')} onMouseLeave={() => setActive('')}><span></span>Middle East - <p>(300K)</p></li>
                    <li id='Africa' className={active == 'dz' || active == 'ao' || active == 'bj' || active == 'bw' || active == 'bf' || active == 'bi' || active == 'cv' || active == 'cm' || active == 'cf' || active == 'td' || active == 'km' || active == 'cg' || active == 'cd' || active == 'ci' || active == 'dj' || active == 'eg' || active == 'gq' || active == 'er' || active == 'sz' || active == 'et' || active == 'ga' || active == 'gm' || active == 'gh' || active == 'gn' || active == 'gw' || active == 'ke' || active == 'ls' || active == 'lr' || active == 'ly' || active == 'mg' || active == 'mw' || active == 'ml' || active == 'mr' || active == 'mu' || active == 'ma' || active == 'mz' || active == 'na' || active == 'ne' || active == 'ng' || active == 'rw' || active == 'st' || active == 'sn' || active == 'sc' || active == 'sl' || active == 'so' || active == 'za' || active == 'ss' || active == 'sd' || active == 'tz' || active == 'tg' || active == 'tn' || active == 'ug' || active == 'zm' || active == 'zw' || active == 'Africa' ? 'active' : ''} onMouseEnter={() => setActive('Africa')} onMouseLeave={() => setActive('')}><span></span>Africa - <p>(200K)</p></li>
                    <li id='Europe' className={active == 'al' || active == 'ad' || active == 'am' || active == 'at' || active == 'az' || active == 'by' || active == 'be' || active == 'ba' || active == 'bg' || active == 'hr' || active == 'cy' || active == 'cz' || active == 'dk' || active == 'ee' || active == 'fi' || active == 'fr' || active == 'ge' || active == 'de' || active == 'gr' || active == 'hu' || active == 'is' || active == 'ie' || active == 'it' || active == 'kz' || active == 'xk' || active == 'lv' || active == 'li' || active == 'lt' || active == 'lu' || active == 'mt' || active == 'md' || active == 'mc' || active == 'me' || active == 'nl' || active == 'mk' || active == 'no' || active == 'pl' || active == 'pt' || active == 'ro' || active == 'ru' || active == 'sm' || active == 'rs' || active == 'sk' || active == 'si' || active == 'es' || active == 'se' || active == 'ch' || active == 'tr' || active == 'ua' || active == 'gb' || active == 'va' || active == 'Europe' ? 'active' : ''} onMouseEnter={() => setActive('Europe')} onMouseLeave={() => setActive('')}><span></span>Europe - <p>(100K)</p></li>
                    <li id='Americas' className={active == 'ca' || active == 'us' || active == 'mx' || active == 'bm' || active == 'gl' || active == 'pm' || active == 'bz' || active == 'cr' || active == 'sv' || active == 'gt' || active == 'hn' || active == 'ni' || active == 'pa' || active == 'ag' || active == 'bs' || active == 'bb' || active == 'cu' || active == 'dm' || active == 'do' || active == 'gd' || active == 'ht' || active == 'jm' || active == 'kn' || active == 'lc' || active == 'vc' || active == 'tt' || active == 'ar' || active == 'bo' || active == 'br' || active == 'cl' || active == 'co' || active == 'ec' || active == 'gy' || active == 'py' || active == 'pe' || active == 'sr' || active == 'uy' || active == 've' || active == 'Americas' ? 'active' : ''} onMouseEnter={() => setActive('Americas')} onMouseLeave={() => setActive('')}><span></span>The Americas - <p>(85K)</p></li>
                    {/* <li id='thvnidmyph' className={active == 'th' || active == 'vn' || active == 'id' || active == 'my' || active == 'ph' || active == 'thvnidmyph' ? 'active' : ''} onMouseEnter={() => setActive('thvnidmyph')} onMouseLeave={() => setActive('')}><span></span>South East Asia <p>(20K)</p></li> */}
                  </ul>
                </div>
              </div>
              <div className='col-xl-9 col-lg-8 order_1'>
                {/* background-image: linear-gradient(to bottom, rgba(240, 212, 179, 0), #f0d3b2 60%); */}
                <div className='right-section'>
                  <SVGMap
                    onLocationMouseOver={handleLocationMouseOver}
                    onLocationMouseOut={handleLocationMouseOut}
                    map={world} />

                  {tooltip?.visible && (
                    <div
                      className="tooltip"
                      style={{
                        position: "absolute",
                        left: tooltip.x + 10,
                        top: tooltip.y + 10,
                      }}
                    >
                      {tooltip?.name}
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>



        </div>
      </section>
    </>
  );
}
